var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "358px",
    height: "200px",
    viewBox: "0 0 358 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L352,0 C355.313708,-6.08718376e-16 358,2.6862915 358,6 L358,200 L358,200 L0,200 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6602481,0 L26.406075,0 C28.0291282,1.47820681e-15 29.3578594,1.29082751 29.404819,2.9132012 L29.4204223,3.4522673 C29.4760716,5.37484912 31.0506745,6.90453461 32.9740616,6.90453461 L84.3079236,6.90453461 C86.2313106,6.90453461 87.8059136,5.37484912 87.8615628,3.4522673 L87.8771661,2.9132012 C87.9241258,1.29082751 89.252857,-7.3537432e-15 90.8759102,0 L102.621737,0 C110.718368,-1.48732707e-15 117.281985,6.56361667 117.281985,14.6602481 L117.281985,232.146187 C117.281985,242.375605 108.989403,250.668187 98.7599851,250.668187 L18.522,250.668187 C8.29258186,250.668187 4.8054561e-15,242.375605 0,232.146187 L0,14.6602481 C-2.76790822e-15,6.56361667 6.56361667,1.48732707e-15 14.6602481,0 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "81.1767625%",
    x2: "50%",
    y2: "-34.5130789%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C19",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC967",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.1100647%",
    y1: "31.3809088%",
    x2: "62.1100647%",
    y2: "-27.4779882%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FDFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAD4FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.0391388,7.18022133e-14 L64.6639862,7.18022133e-14 C70.1715851,7.25668406e-14 74.642396,4.45338093 74.6639099,9.9609378 L74.9607849,85.9609378 C74.9823584,91.4837432 70.5227288,95.9783502 64.9999234,95.9999237 C64.9869027,95.9999746 64.973882,96 64.9608612,96 L10.3360138,96 C4.82841491,96 0.357603981,91.5466191 0.336090087,86.0390622 L0.0392150867,10.0390622 C0.0176416283,4.51625684 4.47727123,0.0216497515 10.0000766,7.62930723e-05 C10.0130973,2.54310726e-05 10.026118,7.18046052e-14 10.0391388,7.18022133e-14 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-51.3%",
    y: "-39.1%",
    width: "223.9%",
    height: "196.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 9,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0755212756   0 0 0 0 0.582569014   0 0 0 0 0.878793025  0 0 0 0.229458042 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.50398247   0 0 0 0 0.700178215   0 0 0 0 1  0 0 0 0.233828671 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-9",
    cx: 14.4218519,
    cy: 14.89752,
    rx: 14.4218519,
    ry: 14.89752
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-133.5%",
    y: "-125.9%",
    width: "422.4%",
    height: "412.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 9,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0755212756   0 0 0 0 0.582569014   0 0 0 0 0.878793025  0 0 0 0.229458042 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.50398247   0 0 0 0 0.700178215   0 0 0 0 1  0 0 0 0.233828671 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.3426384%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCA1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.2730365%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCA1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.9109269%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCA1",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCDD-Pages-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Knowledge-Base",
    transform: "translate(-1052.000000, -445.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(1052.000000, 445.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "File-Organizer",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.000000, 50.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone3",
    transform: "translate(38.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 L110.847537,0 C119.684093,-1.623249e-15 126.847537,7.163444 126.847537,16 L126.847537,237.693211 C126.847537,251.575993 115.593319,262.830211 101.710537,262.830211 L25.137,262.830211 C11.2542182,262.830211 -1.97216578e-14,251.575993 -1.78690945e-14,237.693211 L-1.78690945e-14,16 C-1.89512605e-14,7.163444 7.163444,1.623249e-15 16,0 Z",
    id: "Rectangle",
    fill: "#BCF8FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-48",
    transform: "translate(4.574829, 5.296406)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.581903,43.0353365 L100.582795,43.0353365 C102.402764,43.0353365 103.878141,44.5107132 103.878141,46.3306826 C103.878141,48.150652 102.402764,49.6260286 100.582795,49.6260286 L17.581903,49.6260286 C15.7619336,49.6260286 14.2865569,48.150652 14.2865569,46.3306826 C14.2865569,44.5107132 15.7619336,43.0353365 17.581903,43.0353365 Z",
    id: "Rectangle",
    fill: "#FFCC7B",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.2993875,4.6013265 C71.3844766,4.6013265 72.2641152,5.44439889 72.2641152,6.48438139 C72.2641152,7.50125317 71.4231373,8.32986916 70.371415,8.36619438 L70.2993875,8.36743628 L48.083131,8.36743628 C46.9980418,8.36743628 46.1184033,7.52436389 46.1184033,6.48438139 C46.1184033,5.46750961 46.9593812,4.63889362 48.0111035,4.6025684 L48.083131,4.6013265 L70.2993875,4.6013265 Z",
    id: "Path",
    fill: "#56CDD9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2613488,4.28748402 C79.346438,4.28748402 80.2260765,5.16568442 80.2260765,6.24899953 C80.2260765,7.30824096 79.3850986,8.17138262 78.3333763,8.20922139 L78.2613488,8.21051504 L78.1582983,8.21051504 C77.0732092,8.21051504 76.1935706,7.33231463 76.1935706,6.24899953 C76.1935706,5.18975809 77.0345485,4.32661644 78.0862708,4.28877767 L78.1582983,4.28748402 L78.2613488,4.28748402 Z",
    id: "Path",
    fill: "#56CDD9",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(46.000000, 88.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0.433263158 L6.60705213,0.433263158 C7.97258387,0.433263158 9.07956606,1.54024535 9.07956606,2.90577708 L9.07956606,4.15901421 C9.07956606,4.83240219 9.62545488,5.37829101 10.2988429,5.37829101 L37.2370947,5.37829101 C39.4462337,5.37829101 41.2370947,7.16915201 41.2370947,9.37829101 L41.2370947,30.1238063 C41.2370947,32.3329453 39.4462337,34.1238063 37.2370947,34.1238063 L4,34.1238063 C1.790861,34.1238063 2.23265109e-15,32.3329453 0,30.1238063 L0,4.43326316 C-2.705415e-16,2.22412416 1.790861,0.433263158 4,0.433263158 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9215672,2.77288421 L41.5175766,2.77288421 C42.1909646,2.77288421 42.7368534,3.31877303 42.7368534,3.99216101 C42.7368534,4.0586539 42.7314142,4.12503537 42.7205901,4.19064134 L38.1434578,31.9331993 C38.04631,32.5220236 37.5372288,32.9539958 36.9404443,32.9539958 L6.34443486,32.9539958 C5.67104688,32.9539958 5.12515806,32.408107 5.12515806,31.734719 C5.12515806,31.6682261 5.1305973,31.6018446 5.14142136,31.5362387 L9.71855373,3.79368068 C9.81570147,3.20485637 10.3247827,2.77288421 10.9215672,2.77288421 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7492039,15.226266 L43.1639128,28.0811991 C42.4126686,31.8166368 39.1311815,34.5038793 35.3209502,34.5038793 L4.8845419,34.5038793 C2.6754029,34.5038793 0.8845419,32.7130183 0.8845419,30.5038793 C0.8845419,30.2390416 0.910843878,29.9748584 0.963060607,29.7152194 L3.54835167,16.8602863 C4.29959584,13.1248486 7.58108301,10.4376061 11.3913143,10.4376061 L41.8277226,10.4376061 C44.0368616,10.4376061 45.8277226,12.2284671 45.8277226,14.4376061 C45.8277226,14.7024438 45.8014206,14.966627 45.7492039,15.226266 Z",
    id: "Rectangle",
    fill: "#FFCC7B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(0.000000, 30.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L22.7276371,0 L22.7276371,0 L30,7.36842105 L30,29 C30,32.3137085 27.3137085,35 24,35 L6,35 C2.6862915,35 4.05812251e-16,32.3137085 0,29 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z",
    id: "Rectangle",
    fill: "#8AD4DD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(6.875000, 11.666667)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.30707126,14.09211 C4.96392551,14.09211 6.30707126,12.7725282 6.30707126,11.1447416 C6.30707126,9.51695498 4.96392551,8.19737319 3.30707126,8.19737319 C1.65021701,8.19737319 0.307071263,9.51695498 0.307071263,11.1447416 C0.307071263,12.7725282 1.65021701,14.09211 3.30707126,14.09211 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,12.8199878 C12.1568542,12.8199878 13.5,11.500406 13.5,9.87261936 C13.5,8.24483273 12.1568542,6.92525094 10.5,6.92525094 C8.84314575,6.92525094 7.5,8.24483273 7.5,9.87261936 C7.5,11.500406 8.84314575,12.8199878 10.5,12.8199878 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "13.5 0.370668518 13.5 9.65085235 12.375 9.65085235 12.3745421 2.62688381 6.29804212 4.56183118 6.29804212 11.0563539 5.17304212 11.0563539 5.17362139 3.02148672"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30,7.36842105 L25.7276371,7.36842105 C24.0707829,7.36842105 22.7276371,6.0252753 22.7276371,4.36842105 L22.7276371,0 L22.7276371,0 L30,7.36842105 Z",
    id: "Path",
    fill: "#58A4AD",
    fillRule: "nonzero",
    opacity: 0.339960007
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(108.000000, 20.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.6447368,59.3684211 L49.3552632,59.3684211 C50.4016974,59.3684211 51.25,60.2167236 51.25,61.2631579 C51.25,62.3095922 50.4016974,63.1578947 49.3552632,63.1578947 L25.6447368,63.1578947 C24.5983026,63.1578947 23.75,62.3095922 23.75,61.2631579 C23.75,60.2167236 24.5983026,59.3684211 25.6447368,59.3684211 Z",
    id: "Rectangle",
    fill: "#8AD4DD",
    fillRule: "nonzero",
    opacity: 0.339960007
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3947368,69.4736842 L55.6052632,69.4736842 C56.6516974,69.4736842 57.5,70.3219868 57.5,71.3684211 C57.5,72.4148553 56.6516974,73.2631579 55.6052632,73.2631579 L19.3947368,73.2631579 C18.3483026,73.2631579 17.5,72.4148553 17.5,71.3684211 C17.5,70.3219868 18.3483026,69.4736842 19.3947368,69.4736842 Z",
    id: "Rectangle",
    fill: "#8AD4DD",
    fillRule: "nonzero",
    opacity: 0.339960007
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon8",
    transform: "translate(23.125000, 15.789474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-70",
    transform: "translate(8.750000, 6.947368)",
    fill: "#8AD4DD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.78082972,8.51162038 C10.4966298,8.51162038 11.8875606,9.90255119 11.8875606,11.6183513 L11.8875606,13.4133514 C11.8875606,14.1378003 11.3002787,14.7250822 10.5758298,14.7250822 L1.31173083,14.7250822 C0.587281895,14.7250822 1.64366289e-12,14.1378003 1.64313008e-12,13.4133514 L1.64313008e-12,11.6183513 C1.64291995e-12,9.90255119 1.39093081,8.51162038 3.10673091,8.51162038 L8.78082972,8.51162038 Z M5.94378031,4.97824004e-13 C7.98129293,4.97824004e-13 9.63302326,1.66911697 9.63302326,3.72807709 C9.63302326,5.78703721 7.98129293,7.45615418 5.94378031,7.45615418 C3.90626769,7.45615418 2.25453736,5.78703721 2.25453736,3.72807709 C2.25453736,1.66911697 3.90626769,4.97824004e-13 5.94378031,4.97824004e-13 Z",
    id: "Combined-Shape"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Wom3.5",
    transform: "translate(145.000000, 43.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RArm",
    transform: "translate(61.839472, 35.913054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.20917277,48.2702671 C9.20917277,48.2702671 2.62283378,55.5346617 3.08180927,56.1899663 C3.54123898,56.8495811 6.95582105,55.0926104 6.95582105,55.0926104 C6.95582105,55.0926104 2.9605946,62.5772033 3.88544228,63.0904819 C4.8098376,63.6037602 9.33920968,62.2437825 10.6702927,60.6755489 C12.0018282,59.1073156 13.7936913,51.4403931 13.7936913,51.4403931 L23.3405872,30.9948008 L15.5597885,28.7084251 L9.20917277,48.2702671 Z",
    id: "Path",
    fill: "url(#linearGradient-11)",
    transform: "translate(13.199738, 45.954558) rotate(2.866471) translate(-13.199738, -45.954558) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00979003,11.2029609 C4.92480063,15.7715252 14.7374949,28.7914392 14.7374949,28.7914392 C14.7374949,28.7914392 14.4991576,29.6572943 14.022483,31.3890044 L23.0402312,37.6245292 C24.7481106,32.8656896 25.676149,30.1515142 25.8243465,29.4820031 C26.5574782,26.1693155 11.7424618,5.02889988 8.42530526,1.97423381 C3.20215219,-2.83578862 -2.44519863,4.22128767 2.00979003,11.2029609 Z",
    id: "Path",
    fill: "#FFB66F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0829118,32.2477292 C17.1950348,32.0271149 16.4180948,30.8594364 14.7520919,28.7446935 L14.3286774,30.2873214 C16.0527106,31.8148742 16.9707887,32.4683434 17.0829118,32.2477292 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-70",
    fill: "#FFEDC2",
    points: "13.9665154 30.5174496 23.5470174 37.8967613 21.4121766 42.6692265 13.0354144 33.2714143"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg",
    transform: "translate(45.725454, 76.703990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.94022732 L17.6956478,-7.11789582e-14 L17.9558262,0.243692984 C19.2170281,1.45577177 24.6979461,7.08483308 26.2728098,14.7788056 C29.2460288,29.3044211 25.2667843,56.132275 25.3548024,62.0150653 C25.4388197,67.8978556 28.1949117,71.4473458 29.3402301,79.7651279 C30.4855484,88.0829101 30.5937006,125.256265 30.5937006,125.256265 C27.5570746,127.071383 24.8851299,127.201323 21.2643835,125.14731 L0,1.94022732 Z",
    id: "Path",
    fill: "#383D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8068268,93.5243888 L4.74137402e-14,1.94022732 L9.83882485,0.861366527 C10.2771988,32.6774948 16.3958323,75.6842315 15.8068268,93.5243888 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg",
    transform: "translate(30.629091, 79.224103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.31855298,0.679155991 L26.1891946,0 L26.3376663,0.277257677 C27.3018493,2.12179284 32.5850106,12.9216091 30.9536589,25.1971357 C28.663824,42.4275901 22.8428896,62.6271184 22.5579006,65.7128758 C22.0497958,71.2144488 23.0660053,75.1980457 23.4826973,80.8804728 C23.8993892,86.5628999 21.8937637,122.301345 21.8937637,122.301345 C18.9451558,124.090233 15.4364326,124.441312 10.975513,122.35542 C8.29081241,89.9930037 6.93854451,71.2510006 6.91870927,66.1294102 C6.8889564,58.4470247 6.31855298,0.679155991 6.31855298,0.679155991 Z",
    id: "Path",
    fill: "#42474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4073195,19.3159727 L10.2754757,20.5926093 C8.95121986,34.0544268 8.96125005,62.6423964 9.47404607,67.0513374 L9.54441585,67.6195874 C10.1131756,72.5947386 10.131618,85.2255075 9.5997429,105.511894 L8.90742009,96.758013 C7.59546478,79.9135144 6.93255321,69.704008 6.91870927,66.1294102 L6.89467494,62.4299834 C6.78057975,47.4711296 6.31855298,0.679155991 6.31855298,0.679155991 L10.5092082,0.536078706 C10.957123,7.92246273 10.9231601,14.1824274 10.4073195,19.3159727 Z",
    id: "Path",
    fill: "#51565E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(42.749140, 2.108783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.77550717,13.9891161 C-0.669481689,14.2589161 -0.496142926,18.5944881 2.48017486,18.8208551 C3.08850268,23.0003626 5.25797414,24.991656 7.9029412,25.2220718 L7.75624187,31.543784 L19.455696,31.5367905 C19.455696,31.5367905 16.1611648,27.0709195 16.3253804,20.9571705 C16.4895961,14.8430534 16.2151735,9.09958919 16.2151735,9.09958919 L1.06171639,9.37380611 L1.77550717,13.9891161 Z",
    id: "Path",
    fill: "url(#linearGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7194969,14.3139465 C16.8718246,13.1780781 14.7682315,18.0685279 12.5893462,21.467533 C10.4104609,24.8665382 4.76532526,24.2890199 3.98729135,21.467533 C1.04171508,15.2878187 -1.49670936,6.88625824 1.94065803,6.19669497 C2.42450042,-2.73468654 25.6010965,-0.626096738 19.7194969,14.3139465 Z",
    id: "Path",
    fill: "#9E5229",
    transform: "translate(10.481470, 12.347932) scale(-1, 1) translate(-10.481470, -12.347932) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.320238,2.81643513 C18.31255,3.66712255 18.9464106,4.79617834 19.0222812,6.19669497 C22.4596486,6.88625824 19.9212242,15.2878187 16.9756479,21.467533 C16.252139,24.0912885 11.3198031,24.7745718 8.87988849,22.1241523 C6.65484157,15.3999117 7.60544617,7.88238198 12.1043134,2.81743532 L12.1043134,2.81743532 Z",
    id: "Combined-Shape",
    fillOpacity: 0.199355332,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FB9934",
    cx: 14.0480232,
    cy: 2.81743532,
    rx: 2.79330309,
    ry: 2.81743532
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(34.232790, 31.645886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.305922,3.2310607 C32.9160478,7.09852655 37.2661636,20.2245646 37.5128876,23.1775019 C37.7908659,26.5837247 34.1705291,32.0097684 34.1109624,36.9407646 C34.0580141,41.8724324 36.8113232,56.7211726 35.9840068,58.1082462 C35.1633089,59.4953197 11.6306074,65.636429 10.0951081,65.6035153 C8.56622729,65.56993 -1.0863882,57.2115182 0.124803067,54.323181 C1.34261286,51.4348438 6.99483877,44.2569899 6.41902653,40.3214625 C5.84983282,36.3866068 2.54436971,21.8609575 0.902973901,16.9171989 C-0.731803382,11.9734403 -0.186689093,6.78303259 2.86445393,4.65573865 C4.3741752,3.60314266 8.40276719,0.612709819 15.5769712,0.626096738 C22.7511752,0.640128115 30.1035092,2.93114235 30.305922,3.2310607 Z",
    id: "Path",
    fill: "#FF9F43",
    transform: "translate(18.764055, 33.115194) scale(-1, 1) translate(-18.764055, -33.115194) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3227139,0.343568304 C15.1214305,1.45230991 15.4613604,2.00668072 16.3425033,2.00668072 C17.6642178,2.00668072 26.5296213,2.30116744 27.7301983,1.77529569 C28.530583,1.42471453 28.8106949,0.947472066 28.5705338,0.343568304 L15.3227139,0.343568304 Z",
    id: "Path-68",
    fill: "#FFF6E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.43387088,11.5956284 L3.51421207,11.5547846 C8.34815065,9.12086961 11.251753,9.01336227 12.2250191,11.2322626 C13.4831459,14.1006025 10.2205114,20.9927477 2.43711558,31.9086983 C1.3680376,28.5981062 -0.169547976,25.4416046 0.0152231085,23.1775019 C0.15800698,21.4685804 1.67508208,16.3525256 3.43387088,11.5956284 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm",
    transform: "translate(0.000000, 16.509008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.42102101,18.6702047 C5.42102101,18.6702047 4.55019742,16.76352 3.18131842,16.2476396 C1.81282843,15.7317591 -0.280606518,12.314824 0.0430386438,11.3225657 C0.366683805,10.3303074 3.19818997,7.57842358 3.19818997,7.57842358 C3.19818997,7.57842358 0.694996926,0.802750548 1.8036372,0.038121088 C2.78313061,-0.637725309 6.4898791,7.89679103 6.4898791,7.89679103 C6.4898791,7.89679103 8.66903799,8.22806528 9.17201058,9.10064243 C10.4393615,11.3002721 9.4813674,16.2476396 9.4813674,16.2476396 L22.3464247,35.2094739 L16.4432796,42.8438775 L5.42102101,18.6702047 Z",
    id: "Path",
    fill: "url(#linearGradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2620688,20.1405266 C33.9110834,24.0391919 23.2688133,34.3825069 23.2688133,34.3825069 C23.2688133,34.3825069 22.7417418,33.5679177 21.6875988,31.9387394 L13.7287958,40.1591177 C17.7312828,46.1470971 20.3842172,49.1620047 21.6875988,49.2038406 C26.7815689,49.3672665 35.9086758,39.6666129 44.489492,32.0919686 C52.1831785,25.3002229 46.3724983,12.8732261 38.2620688,20.1405266 Z",
    id: "Path",
    fill: "#FFB66F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3005616,34.3946534 C21.3102782,36.7164297 20.2330234,37.7507244 20.0687972,37.4975375 C19.9045711,37.2443506 20.6552192,35.7065274 22.3207415,32.8840678 L23.3005616,34.3946534 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-69",
    fill: "#FFEDC2",
    points: "22.6404191 32.4924293 13.4097853 42.8438775 10.5658178 36.9365696 20.8843069 30.4054202"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.9260734,2.68383171 C64.9260734,2.68383171 62.3123003,-0.750300895 59.2940221,0.150663334 C56.2757439,1.05162756 53.5455443,6.57440381 54.8418981,11.7657059 C56.1317046,16.9576804 55.0680363,19.9189608 53.5032456,23.4179294 C49.2999168,32.8303161 63.8529366,38.8066201 63.8529366,38.8066201 C63.0959329,34.1569587 63.4536452,30.428307 64.9260734,27.6206652 C67.2007144,23.2833554 68.4925372,17.721317 68.4925372,14.3176691 C68.4925372,8.39882353 64.9260734,2.68383171 64.9260734,2.68383171 Z",
    id: "Path",
    fill: "#9E5229",
    transform: "translate(60.616810, 19.403310) scale(-1, 1) translate(-60.616810, -19.403310) "
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.fb3b32d5ac3dc6fe1eafe5091982f805.svg";
export { ForwardRef as ReactComponent };